var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 140,
    viewBox: "0 0 355 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_6547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 135.333C63.5 96.6428 122 57.9523 180.5 42.4761C239 26.9999 297.5 23.1309 356 19.2618V135.333C297.5 135.333 239 135.333 180.5 135.333C122 135.333 63.5 135.333 5 135.333Z",
    fill: "#406AFF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 135.333C63.5 96.6428 122 57.9523 180.5 42.4761C239 26.9999 297.5 23.1309 356 19.2618",
    stroke: "#5B5EE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_6547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 140,
    fill: "white",
    transform: "translate(0 0.333252)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivision);
export default __webpack_public_path__ + "static/media/division.a846de8000014d3c70cbc21544e78077.svg";
export { ForwardRef as ReactComponent };